import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from "@angular/core";
import { AbstractControl, FormGroup } from "@angular/forms";
import { htmlDecoder } from "@app/shared/resources/html-decoder";
import { DataConverterService } from "@app/shared/services/converter/data-converter.service";
import { Subject } from "rxjs";
import { distinctUntilChanged, takeUntil } from "rxjs/operators";

@Component({
    selector: "clare-slider",
    templateUrl: "./clare-slider.component.html",
    styleUrls: ["./clare-slider.component.scss"],
})
export class ClareSliderComponent implements OnInit, OnDestroy {
    @Input() metaData: any;
    @Input() theForm: FormGroup;
    @Input() enableRetry: boolean;
    private formControl: AbstractControl;
    @Input() isLoading: boolean;
    @ViewChild("slider", { static: true }) sliderCtrl;
    @Output() getValueEmitter = new EventEmitter<void>();

    public unit: string;
    public min: number;
    public max: number;
    public step: number;
    public disabled: boolean;
    // public fieldValue: number;

    private unsubscribe$: Subject<void> = new Subject<void>();

    constructor(private readonly dataConverter: DataConverterService) {}

    ngOnDestroy(): void {
        this.unsubscribe$.next(null);
        this.unsubscribe$.complete();
    }

    ngOnInit() {
        if (this.metaData) {
            this.min = this.getOutputValue(this.metaData.min);
            this.max = this.getOutputValue(this.metaData.max);
            this.step = this.metaData.step;
            this.unit = this.decodeHTML(this.metaData.unit);
            this.formControl = this.theForm.controls[this.metaData.inputName];
            this.disabled = this.formControl.disabled;
            this.sliderCtrl.value = this.getOutputValue(this.formControl.value);
        }

        this.formControl.valueChanges.pipe(distinctUntilChanged(), takeUntil(this.unsubscribe$)).subscribe(value => {
            this.sliderCtrl.value = this.getOutputValue(value);

            if (value === null) {
                this.formControl.disable({ emitEvent: false });
            } else {
                this.formControl.enable({ emitEvent: false });
            }
            this.disabled = this.formControl.disabled;
        });
    }

    decodeHTML(htmlCode: string) {
        return htmlDecoder(htmlCode, true);
    }

    stoppedSliding() {
        if (!this.disabled) {
            this.formControl.setValue(this.getInputValue(this.sliderCtrl.value));
        }
    }

    getOutputValue(value) {
        let _value = value;

        if (this.metaData) {
            _value = this.dataConverter.getOutputValue(value, this.metaData.conversionKey, null);
        }
        return _value;
    }

    getInputValue(value) {
        let _value = value;

        if (this.metaData) {
            _value = this.dataConverter.getInputValue(value, this.metaData.conversionKey, null);
        }
        return _value;
    }

    isNumber(value): boolean {
        return typeof value === "number";
    }
}
